import { Pagination } from 'core/models/response';
import { Notification } from './notificationModel';

export const notificationCompanyUserChannel = (companyId: string | number) => `public:company-user.${companyId}`;

export const NOTIFICATIONS_UPDATED = 'notifications.updated';

export interface NotificationsUpdatedEvent {
	unread_count: number;
	last_notification: Notification | null;
	notifications: {
		notifications: Notification[];
		pagination: Pagination;
	};
}